import { render, staticRenderFns } from "./sideNav.vue?vue&type=template&id=65d975b2&scoped=true&"
import script from "./sideNav.vue?vue&type=script&lang=js&"
export * from "./sideNav.vue?vue&type=script&lang=js&"
import style0 from "./sideNav.vue?vue&type=style&index=0&id=65d975b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d975b2",
  null
  
)

export default component.exports